import React from "react";
import { iconEnum } from "./iconEnum";
import { Link } from "react-router-dom";

const SettingCard = ({ title, subtitle = "", to, icon }) => {
  return (
    <div className="dashboard__card score-card">
      {icon ? iconEnum(icon, { className: "mt-1 mb-2", size: "24" }) : null}
      {to ? (
        <Link to={to} className="dashboard__card__title">
          {title}
        </Link>
      ) : (
        <p className="dashboard__card__title">{title}</p>
      )}
      {subtitle !== "" && (
        <p className="dashboard__card__subtitle">{subtitle}</p>
      )}
    </div>
  );
};

export default SettingCard;
